import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";

import cx from 'classnames';
import _ from 'lodash';

import {
  Form,
  Dropdown,
  Button,
  OverlayTrigger,
  Popover
} from "react-bootstrap";
import { toast } from 'react-toastify';

import { SuccessToast } from 'components/Toast';
import styles from './hubspot.module.scss';

import { activatingIntegrationSuccedded } from 'actions/integrations/integrations';
import { updateHubspot } from 'actions/integrations/hubspot';

export const HubspotConfiguration = (props) => {
  const dispatch = useDispatch();

  const integrations = useSelector(state => _.get(state, 'integrations.activated.items', []));
  const integration = (integrations || []).filter(item => {
    return item != null;
  }).find(item => {
    return item.type == 'hubspot';
  });

  const customBehavioralEvents = _.get(integration, 'configuration.customBehavioralEvents');
  const supported = _.get(customBehavioralEvents, 'supported', false);
  const saving = useSelector(state => _.get(state, 'integrations.hubspot.changes.saving', false));

  const HubspotInfo = () => {
    return (
      <div className={styles.hubspotInfoContainer}>
          <p className='mb-3 ms-3'>To enable cleverstory to push events to Hubspot, do the following steps:</p>
          <ol>
              <li>Go to your Hubspot account -{'>'} Reports -{'>'} Analytics tool.</li>
              <li>You'll find Custom Behavioral Events listed as a card.</li>
              <li>Under that, Select the respective events and copy the value of 'Internal Name' and paste it into the respective text box here.</li>
              <li>To know more, <a target='_blank' href='https://support.cleverstory.io/en/articles/6771556-cleverstory-x-hubspot-integration'>click here.</a></li>
          </ol>
      </div>
    )
  }

  const [state, setState] = useState({
    email: null,
    errorMsg:"",
    formErrors:{},
    enabled: _.get(customBehavioralEvents, 'enabled', false),
    pageViewedEventName: _.get(customBehavioralEvents, 'pageViewedEvent', null),
    assetViewedEventName: _.get(customBehavioralEvents, 'assetViewedEvent', null),
    assetDownloadEventName: _.get(customBehavioralEvents, 'assetDownloadEvent', null),
    icdownloadEventName: _.get(customBehavioralEvents, 'icdownloadEvent', null),
    region: { type: _.get(integration, 'configuration.region') }
  });

  const handleRegion = (regionData) => {
    if (regionData) {
      setState(state => {
        return {
          ...state,
          region: {
            type: regionData
          }
        }
      })
    }
  }

  const validateForm = () => {
    if (!state.enabled) {
      return null;
    }

    if(state.enabled){
      const errors = {};

      if (!state.pageViewedEventName || state.pageViewedEventName.trim().length === 0) {
        errors.pageViewedEvent = 'Please provide valid Page Viewed Event Name';
      }
      if (!state.assetViewedEventName || state.assetViewedEventName.trim().length === 0) {
        errors.assetViewedEvent = 'Please provide valid Asset Viewed Event Name';
      }
      if (!state.assetDownloadEventName || state.assetDownloadEventName.trim().length === 0) {
        errors.assetDownloadEvent = 'Please provide valid Asset Download Event Name';
      }
      if (!state.icdownloadEventName || state.icdownloadEventName.trim().length === 0) {
        errors.icdownloadEvent = 'Please provide valid Interactive Content Event Name';
      }

      return errors;
    }
  }

  const regionOptions = [
    { key: 'eu1', text: 'eu1', value: 'eu1' },
    { key: 'na1', text: 'na1', value: 'na1' }
  ];
  
  const handleEventNameChange = (e) => {
    let {name,value} = e.target;
    setState(state => {
      return {
        ...state,
        [name]: value
      }
    })
  }

  useEffect(() => {
    if (integration && integration.configuration) {
      let { email, region, customBehavioralEvents } = integration && integration.configuration;
      setState(state => {
        return {
          ...state,
          email: email,
          region: { type: region },
          enabled: _.get(customBehavioralEvents, 'enabled', false),
          pageViewedEventName: _.get(customBehavioralEvents, 'pageViewedEvent', ""),
          assetViewedEventName: _.get(customBehavioralEvents, 'assetViewedEvent', ""),
          assetDownloadEventName: _.get(customBehavioralEvents, 'assetDownloadEvent', ""),
          icdownloadEventName: _.get(customBehavioralEvents, 'icdownloadEvent', "")
        }
      })
    }
  }, [])

  const handleEnable = (value) => {
    setState(state => {
      return {
        ...state,
        enabled: value,
        formErrors: {},
        errorMsg:""
      }
    })
  }

  const handleResetClick = () => {
    setState(state => {
      return {
        ...state,
        region: { type: _.get(integration, 'configuration.region', null) },
        pageViewedEventName: _.get(customBehavioralEvents, 'pageViewedEvent', ""),
        assetViewedEventName: _.get(customBehavioralEvents, 'assetViewedEvent', ""),
        assetDownloadEventName: _.get(customBehavioralEvents, 'assetDownloadEvent', ""),
        icdownloadEventName: _.get(customBehavioralEvents, 'icdownloadEvent', ""),
        enabled: _.get(customBehavioralEvents, 'enabled', false),
        formErrors: {},
        errorMsg: ""
      }
    })
  }

  const handleSaveClick = () => {
    const errors = validateForm();

    if (!_.isEmpty(errors)) {
      setState(state => {
        return {
          ...state,
          formErrors: errors,
          errorMsg:"Make sure all fields are filled !!!"
        }
      })
      return;
    } else {
      setState(state => {
        return {
          ...state,
          formErrors: {},
          errorMsg:""
        }
      })
    }

    var request = {
        region: state.region.type,
        customBehavioralEvents: {
            enabled: state.enabled,
            supported: supported,
            pageViewedEvent: state.pageViewedEventName,
            assetViewedEvent: state.assetViewedEventName,
            assetDownloadEvent: state.assetDownloadEventName,
            icdownloadEvent: state.icdownloadEventName
        }
    };

    dispatch(updateHubspot(request, (response) => {
      toast(
        <SuccessToast
          heading={`Success`}
          description={"Hubspot Integration Updated Successfully"}
        />,
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
        }
      );
      dispatch(activatingIntegrationSuccedded(response))
    }));
  }

  return (
    <div className={styles.hubspotAuthentication}>
      <div className={styles.customContainer}>
          <Form.Group className="mb-3 col-12 col-lg-8" controlId="Email">
            <Form.Label className={styles.inputLabel}>Email</Form.Label>
            <Form.Control
              className={styles.inputField}
              value={state.email}
              type="email"
              placeholder="Enter email" />
          </Form.Group>
          <Form.Group className="mb-3 col-12 col-lg-4" controlId="Region">
            <Form.Label className={styles.inputLabel}>Hubspot Region</Form.Label>
            <Dropdown className={styles.filter}>
              <Dropdown.Toggle className={styles.selected}>
                {state.region.type ? state.region.type : "Select Region"}
              </Dropdown.Toggle>
              <Dropdown.Menu className={styles.filterMenu}>
                {
                  regionOptions.map(data => {
                    return (
                      <Dropdown.Item
                        key={data.key}
                        onClick={() => handleRegion(data.value)}
                      > {data.text} </Dropdown.Item>
                    )
                  })}
              </Dropdown.Menu>
            </Dropdown>
          </Form.Group>
      </div>
      
      {supported && <>
        <div className={styles.toggleSwitchContainer}>
          <div className={cx(styles.content, { [styles.active]: !state.enabled })}>Custom Behavioural Events
              <OverlayTrigger
                    trigger="click"
                    placement="bottom"
                    rootClose
                    overlay={
                      <Popover id="popover-tools-menu" className={styles.hubspotTooltip}>
                          <Popover.Body>
                              <HubspotInfo/>
                          </Popover.Body>
                      </Popover>
                    }>

                  <span className={styles.stepsToEnable}>Steps to enable <img src={'/images/info-circle.svg'} alt=''/></span>
              </OverlayTrigger>
          </div>
          <Form.Check
            type="switch"
            checked={state.enabled}
            onChange={() => handleEnable(!state.enabled)}
            className={styles.toggleSwitch}
            id="customEvents"
          />
        </div>
        {state.errorMsg && <span className={styles.errorMsg}>{state.errorMsg}</span>}

        {state.enabled &&
            <>
              <Form.Group className="mb-3" controlId="Email">
                <Form.Label className={cx(styles.inputLabel, { [styles.active]: !state.enabled })}>Page Viewed Event</Form.Label>
                <Form.Control
                  disabled={!state.enabled}
                  isInvalid={state.formErrors.pageViewedEvent}
                  className={styles.eventInputField}
                  value={state.pageViewedEventName}
                  name="pageViewedEventName"
                  onChange={handleEventNameChange}
                  type="page_viewed"
                  placeholder="Enter your page viewed event name" 
                  autoComplete='off'/>
              </Form.Group>

              <Form.Group className="mb-3" controlId="Email">
                <Form.Label className={cx(styles.inputLabel, { [styles.active]: !state.enabled })}>Asset Viewed Event</Form.Label>
                <Form.Control
                  disabled={!state.enabled}
                  isInvalid={state.formErrors.assetViewedEvent}
                  className={styles.eventInputField}
                  value={state.assetViewedEventName}
                  name="assetViewedEventName"
                  onChange={handleEventNameChange}
                  type="page_viewed"
                  placeholder="Enter your asset viewed event name" 
                  autoComplete='off'/>
              </Form.Group>

              <Form.Group className="mb-3" controlId="Email">
                <Form.Label className={cx(styles.inputLabel, { [styles.active]: !state.enabled })}>Asset Download Event</Form.Label>
                <Form.Control
                  disabled={!state.enabled}
                  isInvalid={state.formErrors.assetDownloadEvent}
                  className={styles.eventInputField}
                  value={state.assetDownloadEventName}
                  name="assetDownloadEventName"
                  onChange={handleEventNameChange}
                  type="page_viewed"
                  placeholder="Enter your asset download event name" 
                  autoComplete='off'/>
              </Form.Group>

              <Form.Group className="mb-3" controlId="Email">
                <Form.Label className={cx(styles.inputLabel, { [styles.active]: !state.enabled })}>Interactive Content Download Event</Form.Label>
                <Form.Control
                  disabled={!state.enabled}
                  isInvalid={state.formErrors.icdownloadEvent}
                  className={styles.eventInputField}
                  value={state.icdownloadEventName}
                  name="icdownloadEventName"
                  onChange={handleEventNameChange}
                  type="page_viewed"
                  placeholder="Enter your interactive content download event name" 
                  autoComplete='off'/>
              </Form.Group>
            </>
        }
        
      </>}

      {props.isAuthenticated &&
        <div className={styles.actionContainer}>
          <Button variant='secondary' onClick={handleResetClick} className={styles.resetButton}>Reset</Button>
          <Button variant='primary' onClick={handleSaveClick} className={styles.saveButton}>{saving ? 'Saving' : 'Save Changes'}</Button>
        </div>
      }
    </div>
  )
}